import React from 'react';
import { EditableComponent } from '@adobe/aem-react-editable-components';

import { OMiniCardContainer as OMiniCardContainerComp } from '@marriott/mi-web-ui-kit';
import clsx from 'clsx';

export const OMiniCardContainerConfig = {
  emptyLabel: 'OMiniCardContainer',
  isEmpty: () => true,
  resourceType: `${process.env['NEXT_PUBLIC_AEM_SITE']}/components/content/o-card-mini-container`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OMiniCardContainer = (props: any) => {
  const model = props.model || {};
  const { styleclass, componentId } = model;

  return (
    <div
      data-testid="o-card-mini-container-comp"
      data-component-name="o-card-mini-container"
      id={componentId}
      className={clsx(styleclass)}
    >
      <EditableComponent config={OMiniCardContainerConfig} {...props}>
        <OMiniCardContainerComp {...props} />
      </EditableComponent>
    </div>
  );
};
